export default "__VITE_ASSET__D$5Pmdsd__"